/**
 * Define available roles below
 *
 * NB! careful! Changes here has to be implemented throughout the application
 * as the code relies on specific roles.
 *
 * Note: this list must be kept i sync with the backend, except 'client' is not
 * supported as user role (clients do not log in to this front end).
 */
export enum AUTHUSERROLE {
    THERAPIST = 'therapist',
    SUPERVISOR = 'supervisor',
    ADMIN = 'admin',
    DEV = 'dev',
    DummyHACK = 0 // HACK! ~ WORKAROUND.. to satisfy typescript enum constraint .. see https://github.com/microsoft/TypeScript/issues/33200
  }

/**
* Type declaration for an array of AUTHUSERROLE's, e.g.: ['therapist', 'admin', ...]
*/
export type AuthUserRolesT = AUTHUSERROLE[]

/**
 * Checks whether a role is a valid AUTHUSERROLE.
 *
 * @param role
 */
export const isAuthUserRole = (role: string | number):
  role is AUTHUSERROLE => Object.values(AUTHUSERROLE).includes(role)

/**
 * Filters an arbitrary string array and returns an array thar only
 * contains the authuser roles. If no authuser roles is present in
 * the array an empty array will be returned
 *
 * @param props
 */
export const filterToAuthUserRoles = (props: string[]): AuthUserRolesT => {
  const roles: AuthUserRolesT = []
  props.forEach((prop) => {
    if (isAuthUserRole(prop)) roles.push(prop)
  })
  return roles
}

/**
   * Checks whether all roles in an array of roles are valid AuthUserRoles.
   * Returns true if all the roles are valid, otherwise false.
   *
   * @param roles
   */
export const isAuthUserRoles = (roles: unknown[]): roles is AuthUserRolesT => {
  if (roles.length < 1) return false
  roles.forEach((role) => {
    if (typeof role !== 'string') return false
    if (!isAuthUserRole(role)) return false
    return true
  })
  return true
}

/**
   * Checks if an array of roles overlaps with another array of roles (the roleList)
   * Returns true if the two arrays have at least one role in common.
   *
   * Use, for instance, to determine if a users roles contains some or more
   * of a designated list of roles that give access to something
   *
   *
   * @param roles
   * @param roleList
   */
export const rolesOverlapsRoleList = (
  roles: AuthUserRolesT,
  roleList: AuthUserRolesT,
) => {
  const intersection = roleList.filter((x) => roles.includes(x))
  return intersection.length > 0
}
